// Hook odpowiedzialny za pobranie zagregowanej listy uslug koszyka
// (dostawa + platnosc + dropshipping + pozostale) wraz z totalami.

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export type CartServicesSummaryItemType = 'DELIVERY' | 'PAYMENT' | 'DROPSHIPPING' | 'SERVICE';

export interface ICartServicesSummaryItem {
  id: number | null;
  type: CartServicesSummaryItemType;
  name: string;
  cost_net: number;
  cost_gross: number;
  cost_net_formatted: string;
  cost_gross_formatted: string;
  tax_percent: number | null;
}

export interface ICartServicesSummaryResponse {
  items: ICartServicesSummaryItem[];
  total_cost_net: number;
  total_cost_gross: number;
  total_cost_net_formatted: string;
  total_cost_gross_formatted: string;
  currency: string;
}

const getCartsServicesSummary = (cartId: number): Promise<ICartServicesSummaryResponse> =>
  axios.get(`/carts/${cartId}/services/summary`);

export const useGetCartsServicesSummary = (
  cartId: number,
  options?: UseQueryOptions<ICartServicesSummaryResponse, IError>
) =>
  useQuery<ICartServicesSummaryResponse, IError>(
    ['cart-services-summary', cartId],
    () => getCartsServicesSummary(cartId),
    options
  );
